import { render, staticRenderFns } from "./instagram-compare.vue?vue&type=template&id=2c8e5fc4&scoped=true&"
import script from "./instagram-compare.vue?vue&type=script&lang=js&"
export * from "./instagram-compare.vue?vue&type=script&lang=js&"
import style0 from "./instagram-compare.vue?vue&type=style&index=0&id=2c8e5fc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8e5fc4",
  null
  
)

export default component.exports